<div class="search">
  <mat-form-field appearance="fill">
    <input matInput placeholder="Search by Chart of Workspace Title" [(ngModel)]="searchValue" (keyup)="search()"
      [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
  </mat-form-field>
  <i-feather class="infoIcon" name="info" matTooltip="You can only push published charts that you have access to. &#13;
      Charts in 'Example Charts' and your 'My Workspace' workspace cannot be pushed." [matTooltipClass]="{ 'tooltipClass' : true }"></i-feather>
  <button mat-raised-button style="margin-bottom: 13px;" (click)="goToTags()">
    <i-feather class="nav-icon" name="filter"></i-feather>Filter by Tags
  </button>
</div>
<div class="chip-list">
  <mat-chip-list #chipList>
    <mat-chip *ngFor="let tag of selectedTags" [removable]="true" class="selected-chip" (removed)="removeTag(tag)">
      <img src="assets/icons/zap.svg" alt="tagIcon" class="tag-icon"><span class="tag-name">{{tag}}</span>
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
  </mat-chip-list>
</div>

<!-- <div class="selected-tags">
</div> -->
<div class="container">
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
  <div class="not-found-container" *ngIf="searchError">
    <img class="not-found-icon" src="../../assets/not_found.svg" />
    <p class="not-found-text header-text subtitle2">
      There was a problem searching Maxis Charts. You may not have access to any charts. Go to <a
        href="https://maxis-charts.cpi.gm.com"> Maxis Charts </a> to check.
    </p>
    <!-- <p class="not-found-text header-text subtitle2">
          Please contact your District Manager or PSC Administrator for access.
      </p> -->
  </div>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" *ngIf="!viewTags && !isLoading && !searchError">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding class="child-node" (click)="selectChart(node)"
      [class.selected]="isSelected(node)">
      <i-feather class="nav-icon" name="bar-chart-2"></i-feather>
      <span class="subtitle6 tag-name">{{node.name}}</span>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name" id="expandBtn">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>
      <img src="assets/icons/workspace.svg" alt="workspace" class="ws-icon">
      <span class="subtitle6 tag-name">{{node.name}}</span>
    </mat-tree-node>
  </mat-tree>
  <div class="tags-container" *ngIf="viewTags">
    <button mat-button (click)="goToSearch()">
      <img class="back-button" alt="button" src="assets/icons/chevron-left.svg">BACK</button>
    <div class="padding-container">
      <div style="margin-bottom: 8px; margin-top: -8px;">
        <img style="vertical-align:bottom; padding-right: 8px" src="assets/icons/filter.svg" alt="filter">
        <span class="subtitle3">Filter by Super Tag</span>
      </div>
      <mat-chip-list #chipList2>
        <mat-chip *ngFor="let tag of tagSearchResults" class="selected-chip" (click)="selectTag(tag)"
          [removable]="selectedTags.indexOf(tag) != -1" (removed)="removeTag(tag)">
          <img src="assets/icons/zap.svg" alt="tagIcon" class="tag-icon"><span class="tag-name">{{tag}}</span>
        </mat-chip>
      </mat-chip-list>
    </div>
  </div>

</div>